import { render } from "./TextCollapse.vue?vue&type=template&id=cc404da6&scoped=true"
import script from "./TextCollapse.vue?vue&type=script&lang=js"
export * from "./TextCollapse.vue?vue&type=script&lang=js"

import "./TextCollapse.vue?vue&type=style&index=0&id=cc404da6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc404da6"]])

export default __exports__